<template>
    <div class="containerGradient">
        <div class="jiben">
            <div class="title_isn">{{ $t('一、基本信息') }}</div>
            <div class="cont">
                <div class="dsb ipu1" style="width: 50%;flex-wrap: wrap;" v-if="formData.basic_info">
                    <div class="List">
                        <div class="leftType">
                            <span style="color: red"></span>{{ $t('客户编号:') }}
                        </div>
                        <el-input :disabled="true" :placeholder="$t('自动生成编号')" v-model="formData.basic_info.user_no"
                            clearable size="small">
                        </el-input>
                    </div>
                    <!-- <div class="List">
                        <div class="leftType"><span style="color: red">*</span>{{ $t('客户类型:') }}</div>
                        <el-select size="small" v-model="formData.basic_info.customer_id" :placeholder="$t('请选择')"
                            style="width: 100%">
                            <el-option v-for="item in customer" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div> -->
                    <div class="List">
                        <div class="leftType">
                            <span style="color: red">*</span>{{ $t('长者姓名:') }}
                        </div>
                        <el-input :placeholder="$t('请输入')" v-model="formData.basic_info.name" clearable size="small">
                        </el-input>
                    </div>
                    <div class="List">
                        <div class="leftType">
                            <span style="color: red">*</span>{{ $t('长者联系电话:') }}
                        </div>
                        <el-input :placeholder="$t('请输入')" v-model="formData.basic_info.phone" clearable size="small">
                        </el-input>
                    </div>
                    <div class="List">
                        <div class="leftType">
                            <span style="color: red">*</span>{{ $t('证件号码:') }}
                        </div>
                        <el-input @blur="cardNumber" size="small" type="text" :placeholder="$t('请输入')"
                            v-model="formData.basic_info.card_no" maxlength="18" show-word-limit>
                        </el-input>
                    </div>
                    <div class="List">
                        <div class="leftType">{{ $t('出生日期:') }}</div>
                        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small"
                            v-model="formData.basic_info.birthday" type="date" :placeholder="$t('选择出生日期')">
                        </el-date-picker>
                    </div>
                    <div class="List">
                        <div class="leftType">
                            <span class="require" style="color: red">*</span>{{ $t('地址：') }}
                        </div>
                        <div>
                            <el-cascader style="width: 540px" size="small" :options="newOptions"
                                v-model="selectedOptions" @change="cityChange">
                            </el-cascader>
                        </div>
                    </div>

                </div>
                <div class="dsb ipu1" style="width: 50%;flex-wrap: wrap;" v-if="formData.basic_info">
                    <div class="List">
                        <div class="leftType">{{ $t('性别：') }}</div>
                        <el-select size="small" v-model="formData.basic_info.gender" :placeholder="$t('请选择')">
                            <el-option v-for="item in gender_Options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="List">
                        <div class="leftType">
                            <span style="color: red"></span>{{ $t('户籍:') }}
                        </div>
                        <el-input :placeholder="$t('请输入')" v-model="formData.basic_info.household_register" clearable
                            size="small">
                        </el-input>
                    </div>
                    
                    <div class="List">
                        <div class="leftType">{{ $t('身高:') }}</div>
                        <el-select size="small" v-model="formData.basic_info.height" :placeholder="$t('请选择')">
                            <el-option v-for="item in heightType" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="List">
                        <div class="leftType">{{ $t('体重:') }}</div>
                        <el-select size="small" v-model="formData.basic_info.weight" :placeholder="$t('请选择')">
                            <el-option v-for="item in weightType" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="List">
                        <div class="leftType">
                            <span style="color: red">*</span>{{ $t('详细地址：') }}
                        </div>
                        <el-input style="width: 540px" :placeholder="$t('请输入')" v-model="formData.basic_info.address"
                            size="small">
                        </el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="jiben">
            <div class="title_isn">{{ $t('二、紧急联系人') }}</div>
            <div class="cont">
                <div class="dsb ipu2" style="width: 55%;flex-wrap: wrap;padding-left: 20px;">
                    <div class="List">
                        <div class="leftType">
                            <span style="color: red">*</span>{{ $t('紧急联系人姓名1:') }}
                        </div>
                        <el-input :placeholder="$t('请输入')" v-model="formData.emergency_contact.emergency_contact_name"
                            size="small">
                        </el-input>
                    </div>
                    <div class="List">
                        <div class="leftType">
                            <span style="color: red">*</span>{{ $t('紧急联系人电话1:') }}
                        </div>
                        <el-input :placeholder="$t('请输入')" v-model="formData.emergency_contact.emergency_contact_phone"
                            size="small">
                        </el-input>
                    </div>
                    


                </div>
                
            </div>
        </div>
        <div class="RowDetail_list">
            <span class="big">{{ $t('回访设置：') }}</span>
            <el-select style="width:120px" v-model="visitValue" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-date-picker style="width: 250px" v-model="visit_plan_time_begin" value-format="yyyy-MM-dd"
                type="daterange" :range-separator="$t('至')" :start-placeholder="$t('计划开始日期')"
                :end-placeholder="$t('计划结束日期')">
            </el-date-picker>
        </div>
        <div class="RowDetail_list">
            <span class="big">{{ $t('回访原因备注：') }}</span>
            <el-input type="textarea" placeholder="请输入内容" v-model="vTextarea" maxlength="150" show-word-limit>
            </el-input>
        </div>
        <div class="dja" style="padding: 20px 0;"><el-button type="primary" class="save dja" @click="saveUser()">{{
            $t('保存') }}</el-button></div>

    </div>
</template>

<script>
import i18n from '../../locales/index'
import bus from "../../libs/bus";
import { get, post, BASE_URL } from "../../libs/tool";
import {

    employeedel,
    update_password,
    getCallRecordByUser,
    saveUserCall,
    userOlist,
    userOadd,
    userOedit,
    userOdel,
    userDetail,
    uploadSign,

    liveStatusList,
    livingConditionList,
    hobbyList,
    healthStatusList,
    exportUser,
    llimportUser,
    getUserCallList,
} from "../../api/api";
import {
    provinceAndCityData,
    regionData,
    provinceAndCityDataPlus,
    regionDataPlus,
    CodeToText,
    TextToCode,
} from "element-china-area-data";
import jq from "jquery";
export default {
    props: {
        caller: {
            type: String,
            required: true
        },
        cc_job_id: {
            type: String,
            required: true
        }
    },
    watch: {
        caller(newVal) {
            this.detailUser()
            console.log('caller changed:', newVal);
        },
        cc_job_id(newVal) {
            if (newVal) {
                this.detailUser()
            }
        },
    },
    data() {
        return {
            // cc_job_id:'',
            options: [{
                value: 0,
                label: '无需回访'
            }, {
                value: 1,
                label: '需要回访'
            },],
            visitValue: 0,
            visitTime: '',
            visit_plan_time_begin: [],
            vTextarea: '',
            isMap: false,
            CallRecordListByJobId: [],
            UploadDialogShow: false,
            importUserHint: false,
            importUserData: [],
            RepeatImportList: [],
            customer_id: '',
            customerData: [],
            selectedOptions1: [],
            newOptions: regionData,
            province: '',
            city: '',
            district: '',
            title: i18n.t('新增长者'),
            dialogType: 'add', // add | edit
            addDialog: false,
            OrderDetailDialog: false,
            nesPaaID: '',
            new_password: '',
            new_password_again: "",
            DistributeVisible: false,
            playMp3: false,
            ccc_config_id: '',
            PPlimit: 10,
            pppage: 1,
            pptotal: 0,

            customer: [],
            bloodType: [],
            liveStatus: [],
            currentAudio: null,
            livingCondition: [],
            ServiceEmployeeData: [],
            healthStatus: [],
            hobby: [],
            selectedDiseases: [],

            heightType: (function generateOptions() {
                let arr = [];
                for (let i = 100; i <= 200; i += 1) {
                    arr.push({
                        value: i + "",
                        label: i + i18n.t("厘米"),
                    });
                }
                return arr;
            })(),
            weightType: (function generateOptions() {
                let arr = [];
                for (let i = 30; i <= 150; i += 2) {
                    arr.push({
                        value: i + "",
                        label: i + i18n.t("kg"),
                    });
                }
                return arr;
            })(),
            confirmType: [

                {
                    value: '0',
                    label: i18n.t("否"),
                },
                {
                    value: '1',
                    label: i18n.t("是"),
                },
            ],
            liveStatusType: [

                {
                    value: '1',
                    label: i18n.t("独居"),
                },
                {
                    value: '2',
                    label: i18n.t("与配偶同住"),
                },
                {
                    value: '3',
                    label: i18n.t("多代同住"),
                },
                {
                    value: '4',
                    label: i18n.t("养老院/护理院"),
                },
            ],
            floorType: [

                {
                    value: '1',
                    label: i18n.t("1楼（无障碍）"),
                },
                {
                    value: '2',
                    label: i18n.t("2-6楼（有电梯）"),
                },
                {
                    value: '3',
                    label: i18n.t("2-6楼（无电梯）"),
                },
                {
                    value: '4',
                    label: i18n.t("6楼以上"),
                },
            ],
            dm_typeType: [

                {
                    value: '1',
                    label: i18n.t("1型"),
                },
                {
                    value: '2',
                    label: i18n.t("2型"),
                },
                {
                    value: '3',
                    label: i18n.t("其他"),
                }
            ],
            chd_typeType: [
                {
                    value: '1',
                    label: i18n.t("心绞痛"),
                },
                {
                    value: '2',
                    label: i18n.t("心肌梗死"),
                }
            ],
            stroke_typeType: [
                {
                    value: '1',
                    label: i18n.t("缺血性"),
                },
                {
                    value: '2',
                    label: i18n.t("出血性"),
                }
            ],
            stroke_sequelaeType: [
                {
                    value: '1',
                    label: i18n.t("肢体障碍"),
                },
                {
                    value: '2',
                    label: i18n.t("语言障碍"),
                },
                {
                    value: '3',
                    label: i18n.t("其他"),
                }
            ],
            nyhaType: [
                {
                    value: '1',
                    label: i18n.t("I级"),
                },
                {
                    value: '2',
                    label: i18n.t("II级"),
                },
                {
                    value: '3',
                    label: i18n.t("III级"),
                },
                {
                    value: '4',
                    label: i18n.t("IV级"),
                }
            ],

            asthma_control_statusType: [
                {
                    value: '1',
                    label: i18n.t("良好"),
                },
                {
                    value: '2',
                    label: i18n.t("一般"),
                },
                {
                    value: '3',
                    label: i18n.t("差"),
                }
            ],
            hoehn_yahrType: [
                {
                    value: '1',
                    label: i18n.t("1期"),
                },
                {
                    value: '2',
                    label: i18n.t("2期"),
                },
                {
                    value: '3',
                    label: i18n.t("3期"),
                },
                {
                    value: '4',
                    label: i18n.t("4期"),
                },
                {
                    value: '5',
                    label: i18n.t("5期"),
                }
            ],
            arrhythmia_typeType: [
                {
                    value: '1',
                    label: i18n.t("房颤"),
                },
                {
                    value: '2',
                    label: i18n.t("早搏"),
                },
                {
                    value: '3',
                    label: i18n.t("其他"),
                }
            ],
            copd_goldType: [
                {
                    value: '1',
                    label: i18n.t("1级（轻度）"),
                },
                {
                    value: '2',
                    label: i18n.t("2级（中度）"),
                },
                {
                    value: '3',
                    label: i18n.t("3级（重度）"),
                },
                {
                    value: '4',
                    label: i18n.t("4级（极重度）"),
                }
            ],
            tumor_treatment_statusType: [
                {
                    value: '1',
                    label: i18n.t("术后随访"),
                },
                {
                    value: '2',
                    label: i18n.t("放化疗中"),
                },
                {
                    value: '3',
                    label: i18n.t("稳定期"),
                }
            ],
            osteoarthritis_jointsType: [
                {
                    value: '1',
                    label: i18n.t("膝"),
                },
                {
                    value: '2',
                    label: i18n.t("髋"),
                },
                {
                    value: '3',
                    label: i18n.t("手"),
                }
                ,
                {
                    value: '4',
                    label: i18n.t("脊柱"),
                }
            ],
            td_typeType: [
                {
                    value: '1',
                    label: i18n.t("甲亢"),
                },
                {
                    value: '2',
                    label: i18n.t("甲减"),
                }
            ],
            mi_typeType: [
                {
                    value: '1',
                    label: i18n.t("抑郁症"),
                },
                {
                    value: '2',
                    label: i18n.t("焦虑症"),
                }
            ],
            symptom_frequencyType: [
                {
                    value: '1',
                    label: i18n.t("每日发作"),
                },
                {
                    value: '2',
                    label: i18n.t("每周数次"),
                },
                {
                    value: '3',
                    label: i18n.t("每周数次"),
                },
                {
                    value: '4',
                    label: i18n.t("无症状"),
                }
            ],
            medication_adherenceType: [
                {
                    value: '1',
                    label: i18n.t("完全按医嘱"),
                },
                {
                    value: '2',
                    label: i18n.t("偶尔漏服"),
                },
                {
                    value: '3',
                    label: i18n.t("经常漏服"),
                }
            ],
            aid_typeType: [
                {
                    value: '1',
                    label: i18n.t("拐杖"),
                },
                {
                    value: '2',
                    label: i18n.t("轮椅"),
                },
                {
                    value: '3',
                    label: i18n.t("助听器"),
                },
                {
                    value: '4',
                    label: i18n.t("其他"),
                }
            ],
            diabetic_foot_typeType: [
                {
                    value: '1',
                    label: i18n.t("1级"),
                },
                {
                    value: '2',
                    label: i18n.t("2级"),
                },
                {
                    value: '3',
                    label: i18n.t("3级"),
                },
                {
                    value: '4',
                    label: i18n.t("4级"),
                },
                {
                    value: '5',
                    label: i18n.t("5级"),
                }
            ],
            chronic_wound_statusType: [
                {
                    value: '1',
                    label: i18n.t("良好"),
                },
                {
                    value: '2',
                    label: i18n.t("迁延不愈"),
                }
            ],


            excelFile: '',
            imgUrl: '',
            fileName: "",
            fileType: "",// 'image' 或 'word'
            isAgreed: true, // 绑定勾选状态
            sign_url: '',
            search_text: "",
            CellStyle: {
                textAlign: "center",
                background: "#F5F5F5",
                color: "#181818",
            },
            tableData: [],
            page: 1,
            limit: 6,
            editID: "",
            radio: false,
            diagnosisYear: '',
            medicationList: [{}, {}, {}],
            formData: {
                basic_info: {},
                emergency_contact: {},


            },
            hobbySev: [],
            healthSev: [],
            newOptions: regionData,
            selectedOptions: [],
            gender_Options: [
                {
                    value: 1,
                    label: i18n.t('男'),
                },
                {
                    value: 2,
                    label: i18n.t('女'),
                },
            ],
            audioUrl: '',
            trueDuration: '',
            callDetail: {
                id: ''
            },
            tid: '',
        };
    },
    computed: {

    },
    mounted() {
        this.getOption()
        this.detailUser()
    },
    methods: {
        saveUser() {
            //       job_id: job-547dcc7d-cd90-4d35-9ad4-b40bf9a000d6
            // user_id: 29255dca65b611eeb42b00163e02d435
            // is_visit: 0
            // visit_plan_time_begin: 2025-03-20T16:00:00.000Z
            // remark: 古古怪怪
            let data = {
                job_id: this.cc_job_id,
                user_id: this.formData.id,
                is_visit: this.visitValue,
                visit_plan_time_begin: Array.isArray(this.visit_plan_time_begin) && this.visit_plan_time_begin.length ? this.visit_plan_time_begin[0] : "",
                visit_plan_time_end: Array.isArray(this.visit_plan_time_begin) && this.visit_plan_time_begin.length ? this.visit_plan_time_begin[1] : "",
                remark: this.vTextarea
            }
            post(saveUserCall, data, (res) => {
                if (res.success) {

                    bus.$emit('getEmployeeListByDate')
                    this.$message({
                        message: "保存成功！",
                        type: "success",
                    });
                } else {
                    this.$message({
                        message: res.message,

                    });
                    // alert("系统异常，请稍后重试！", res);
                }
            });

        },
        detailUser(row) {
            this.formData =  {
                basic_info: {},
                emergency_contact: {}

            }
            this.selectedOptions = [];
            
            let data = {
                // id: row.id,
                caller: this.caller,

            };
            get(getUserCallList, data, (res) => {
                if (res.success) {
                    if (res.data.length > 0) {
                        this.formData = res.data[0];
                        if (res.data.sign_url) {
                            this.imgUrl = res.data.sign_url
                        }
                        if (this.formData.basic_info.province) {
                            if (
                                ["北京市", "天津市", "上海市", "重庆市"].includes(
                                    this.formData.province
                                )
                            ) {
                                console.log(TextToCode);
                                let NewCode = [
                                    TextToCode[this.formData.basic_info.province].code,
                                    TextToCode[this.formData.basic_info.province].市辖区.code,
                                    TextToCode[this.formData.basic_info.province].市辖区[this.formData.basic_info.district].code,
                                ];
                                console.log(NewCode);
                                this.selectedOptions = NewCode;
                            } else if (["香港特别行政区", "澳门特别行政区",].includes(
                                this.formData.basic_info.province
                            )) {
                                console.log(TextToCode[this.formData.basic_info.province], '香港');
                                let NewCode = [
                                    TextToCode[this.formData.basic_info.province].code,
                                    TextToCode[this.formData.basic_info.province][this.formData.basic_info.city].code,
                                ];

                                this.selectedOptions = NewCode;
                            } else {
                                let NewCode = [
                                    TextToCode[this.formData.basic_info.province].code,
                                    TextToCode[this.formData.basic_info.province][this.formData.basic_info.city].code,
                                    TextToCode[this.formData.basic_info.province][this.formData.basic_info.city][this.formData.basic_info.district]
                                        .code,
                                ];
                                this.selectedOptions = NewCode;
                            }
                            // this.selectedOptions = NewCode;
                            console.log(this.selectedOptions, 'this.selectedOptionsEdit');
                        }
                    }


                } else {
                    this.$message(res.message);
                }
            });
        },
        getOption() {
            
            
            // get(liveStatusList, {}, (res) => {
            //     if (res.success) {
            //         this.liveStatus = res.data;
            //     } else {
            //         this.$message(res.message);
            //     }
            // });
            // get(livingConditionList, {}, (res) => {
            //     if (res.success) {
            //         this.livingCondition = res.data;
            //     } else {
            //         this.$message(res.message);
            //     }
            // });
            // get(hobbyList, {}, (res) => {
            //     if (res.success) {
            //         this.hobby = res.data;
            //     } else {
            //         this.$message(res.message);
            //     }
            // });
            // get(healthStatusList, {}, (res) => {
            //     if (res.success) {
            //         this.healthStatus = res.data;
            //     } else {
            //         this.$message(res.message);
            //     }
            // });

        },
    }
};
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
.ipu1  >>>.el-input{
    width: 160px!important;
}
.ipu2  >>>.el-input{
    width: 130px!important;
}
 .title_isn{
            font-size: 15px;
            font-weight: 700;
            padding: 5px 20px;
        }
          .cont {
            //   border-bottom: 1px red solid
              display: flex;
              padding: 5px 0;
              .cont_left{
                /deep/ .el-input {
                 width: 150px!important;
                }
              }
              .List {
                  display: flex;
                  align-items: center;
                  margin-bottom: 10px;
  
                  .leftType {
                      min-width: 100px;
                      text-align: right;
                      // border: 1px red solid
                      flex-shrink: 0;
                      font-size:13px;
                    //   font-weight: 700;
                    //   color: #000;
                  }
  
                  .el-input {
                      // width: 315px;
                  }
  
                  .ImgsBox {
                      img {
                          width: 200px;
                          height: auto;
                          border-radius: 10px;
                      }
                  }
  
                  .uploadImg {
                      // border: 1px #c0c4cc dashed
                  }
  
                  .tips {
                      font-size: 12px;
                      color: #c0c4cc;
                  }
              }
          }
</style>



// WEBPACK FOOTER //
// src/components/CallTab/Incoming.vue